"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _button = require("../../button");
var _tooltip = require("../../tooltip");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ToolboxFunctionsItems = function ToolboxFunctionsItems(_ref) {
  var labels = _ref.labels,
    buttonsId = _ref.buttonsId,
    functionsEnabled = _ref.functionsEnabled,
    reachedMaxNestingPath = _ref.reachedMaxNestingPath,
    disabled = _ref.disabled,
    keysPath = _ref.keysPath,
    actions = _ref.actions,
    clearFocus = _ref.clearFocus;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_button.Button, {
    className: "toolbox-formula-button toolbox-formula-min",
    disabled: !functionsEnabled || reachedMaxNestingPath || disabled,
    onMouseDown: function onMouseDown(ev) {
      ev.stopPropagation();
      actions.addFunctionMin(keysPath);
      clearFocus();
    },
    type: "naked"
  }, reachedMaxNestingPath ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_tooltip.Tooltip, {
    id: "".concat(buttonsId, "-MIN-maxNestingTooltip")
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "toolbox-formula-tooltip",
    "data-tip": "".concat(labels.FORMULA_MAX_NESTING_LABEL),
    "data-offset": "{'top':20, 'left':22}",
    "data-place": "top"
  }, labels.FORMULA_MIN_FUNCTION_LABEL)) : labels.FORMULA_MIN_FUNCTION_LABEL), /*#__PURE__*/_react["default"].createElement(_button.Button, {
    className: "toolbox-formula-button toolbox-formula-max",
    disabled: !functionsEnabled || reachedMaxNestingPath || disabled,
    onMouseDown: function onMouseDown(ev) {
      ev.stopPropagation();
      actions.addFunctionMax(keysPath);
      clearFocus();
    },
    type: "naked"
  }, reachedMaxNestingPath ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_tooltip.Tooltip, {
    id: "".concat(buttonsId, "-MAX-maxNestingTooltip")
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "toolbox-formula-tooltip",
    "data-tip": "".concat(labels.FORMULA_MAX_NESTING_LABEL),
    "data-offset": "{'top':20, 'left':22}",
    "data-place": "top"
  }, labels.FORMULA_MAX_FUNCTION_LABEL)) : labels.FORMULA_MAX_FUNCTION_LABEL), /*#__PURE__*/_react["default"].createElement(_button.Button, {
    className: "toolbox-formula-button toolbox-formula-round",
    disabled: !functionsEnabled || reachedMaxNestingPath || disabled,
    onMouseDown: function onMouseDown(ev) {
      ev.stopPropagation();
      actions.addFunctionRound(keysPath);
      clearFocus();
    },
    type: "naked"
  }, reachedMaxNestingPath ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_tooltip.Tooltip, {
    id: "".concat(buttonsId, "-ROUND-maxNestingTooltip")
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "toolbox-formula-tooltip",
    "data-tip": "".concat(labels.FORMULA_MAX_NESTING_LABEL),
    "data-offset": "{'top':20, 'left':22}",
    "data-place": "top"
  }, labels.FORMULA_ROUND_FUNCTION_LABEL)) : labels.FORMULA_ROUND_FUNCTION_LABEL), /*#__PURE__*/_react["default"].createElement(_button.Button, {
    className: "toolbox-formula-button toolbox-formula-round-up",
    disabled: !functionsEnabled || reachedMaxNestingPath || disabled,
    onMouseDown: function onMouseDown(ev) {
      ev.stopPropagation();
      actions.addFunctionRoundUp(keysPath);
      clearFocus();
    },
    type: "naked"
  }, reachedMaxNestingPath ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_tooltip.Tooltip, {
    id: "".concat(buttonsId, "-ROUND-UP-maxNestingTooltip")
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "toolbox-formula-tooltip",
    "data-tip": "".concat(labels.FORMULA_MAX_NESTING_LABEL),
    "data-offset": "{'top':20, 'left':22}",
    "data-place": "top"
  }, labels.FORMULA_ROUND_UP_FUNCTION_LABEL)) : labels.FORMULA_ROUND_UP_FUNCTION_LABEL), /*#__PURE__*/_react["default"].createElement(_button.Button, {
    className: "toolbox-formula-button toolbox-formula-round-down",
    disabled: !functionsEnabled || reachedMaxNestingPath || disabled,
    onMouseDown: function onMouseDown(ev) {
      ev.stopPropagation();
      actions.addFunctionRoundDown(keysPath);
      clearFocus();
    },
    type: "naked"
  }, reachedMaxNestingPath ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_tooltip.Tooltip, {
    id: "".concat(buttonsId, "-ROUND-DOWN-maxNestingTooltip")
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "toolbox-formula-tooltip",
    "data-tip": "".concat(labels.FORMULA_MAX_NESTING_LABEL),
    "data-offset": "{'top':20, 'left':22}",
    "data-place": "top"
  }, labels.FORMULA_ROUND_DOWN_FUNCTION_LABEL)) : labels.FORMULA_ROUND_DOWN_FUNCTION_LABEL));
};
ToolboxFunctionsItems.defaultProps = {
  disabled: false,
  reachedMaxNestingPath: false
};
ToolboxFunctionsItems.propTypes = {
  reachedMaxNestingPath: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  functionsEnabled: _propTypes["default"].bool.isRequired,
  actions: _propTypes["default"].shape({
    addLeftBracket: _propTypes["default"].func.isRequired,
    addRightBracket: _propTypes["default"].func.isRequired,
    addFunctionMin: _propTypes["default"].func.isRequired,
    addFunctionMax: _propTypes["default"].func.isRequired,
    addFunctionBetween: _propTypes["default"].func.isRequired,
    addFunctionRound: _propTypes["default"].func.isRequired,
    addFunctionRoundUp: _propTypes["default"].func.isRequired,
    addFunctionRoundDown: _propTypes["default"].func.isRequired
  }).isRequired,
  keysPath: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])), _propTypes["default"].number]).isRequired,
  clearFocus: _propTypes["default"].func.isRequired,
  buttonsId: _propTypes["default"].string.isRequired,
  labels: _propTypes["default"].shape({
    FORMULA_MIN_FUNCTION_LABEL: _propTypes["default"].string,
    FORMULA_MAX_FUNCTION_LABEL: _propTypes["default"].string,
    FORMULA_MAX_NESTING_LABEL: _propTypes["default"].string,
    FORMULA_ROUND_FUNCTION_LABEL: _propTypes["default"].string,
    FORMULA_ROUND_UP_FUNCTION_LABEL: _propTypes["default"].string,
    FORMULA_ROUND_DOWN_FUNCTION_LABEL: _propTypes["default"].string
  }).isRequired
};
var _default = exports["default"] = ToolboxFunctionsItems;